import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import MotionContainer from "../../../../../components/FramerMotion/MotionContainer";
import { UpdateButton } from "../../../../../components/mui/Buttons/Buttons";
import { useSnackbar } from "notistack";

const UpdateIsAvailablePayingAmtForOptionBased = ({
  item,
  handleInputChange,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  console.log(item);

  const [open, setOpen] = useState(false);
  const [payingAmt, setPayingAmt] = useState("");

  useEffect(() => {
    if (item && open) {
      setPayingAmt(Number(item.paidAmt));
    }
  }, [item, open]);

  const handlePayingAmountChange = (event) => {
    if (event.target.value) {
      setPayingAmt(event.target.value);
    }
  };
  const handleSubmit = () => {
    const amt = { target: { value: payingAmt } };
    handleInputChange(amt, item.id, "paidAmt");
    setOpen(false);
    enqueueSnackbar("Updated Successfully...", {
      variant: "success",
    });
  };
  return (
    <GlobalDialog
      title={"Update Paying Amount"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      popupButton={
        <Box sx={{ display: "flex", justifyContent: "center", pt: 1 }}>
          <Chip
            variant="outlined"
            color="success"
            size="small"
            label="Update Paying Amount"
            sx={{ height: 15, fontSize: 7 }}
            onClick={() => setOpen(true)}
          />
        </Box>
      }
      content={
        <>
          {open ? (
            <>
              {" "}
              <Box>
                <MotionContainer delay={0.5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Terms</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={payingAmt}
                      label="Terms"
                      onChange={handlePayingAmountChange}
                    >
                      {item?.selectedOptionTerms?.map((item, index) => {
                        return (
                          <MenuItem keys={index} value={item}>
                            {item}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </MotionContainer>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
                <UpdateButton size={"small"} action={handleSubmit}>
                  Update
                </UpdateButton>
              </Box>
            </>
          ) : null}
        </>
      }
    />
  );
};

export default UpdateIsAvailablePayingAmtForOptionBased;
